var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('p',{staticClass:"sub-hero-text"},[_vm._v("coming soon ...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }